import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ChartConfiguration, ChartData } from 'chart.js';
import DatalabelsPlugin from 'chartjs-plugin-datalabels';
import { BaseChartDirective } from 'ng2-charts';
import { AnalyticsResultsService, TransactionCategoryStatistic } from 'src/app/shared/services/analytics-results.service';

@Component({
  selector: 'app-txn-cats-pie-chart',
  templateUrl: './txn-cats-pie-chart.component.html',
  styleUrls: ['../widgets.scss', './txn-cats-pie-chart.component.scss']
})
export class TxnCatsPieChartComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;

  currentYearTxnCats: TransactionCategoryStatistic[] = new Array<TransactionCategoryStatistic>();
  currentYearTxnCatsLoaded: boolean = false;

  constructor(private resultsAnalyticsSvc: AnalyticsResultsService) {

  }

  //chartPlugins = [DatalabelsPlugin];
  chartPlugins = [];

  chartData: ChartData<'pie', number[], string> = {
    labels: [],
    datasets: [{ data: [] }]
  };

  chartOptions: ChartConfiguration['options'] = {
    // We use these empty structures as placeholders for dynamic theming.
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "left",
        labels: {
          boxWidth: 10
        }
      },
      tooltip: {
        callbacks: {
          label: (item) =>
            `${item.label}: $${item.formattedValue}`
        }
      }
    },
  };

  ngOnInit(): void {
    this.resultsAnalyticsSvc.getCategoriesForTransactionsCurrentYear()
      .subscribe({
        next: (data) => {
          this.currentYearTxnCats = data;
          this.buildCatsThisMonthStats();
          this.currentYearTxnCatsLoaded = true;
        },
        error: (err: HttpErrorResponse) => {
          if (err.status == 400) {
            this.currentYearTxnCatsLoaded = false;
          } else {
            throw err;
          }
        }
      });
  }


  buildCatsThisMonthStats() {
    if (this.currentYearTxnCats && this.currentYearTxnCats.length > 0) {

      let filteredData: any[] = new Array<any>();
      let yearMonth: number = 0;
      let yearMonthName: string = "";

      this.currentYearTxnCats.forEach((x) => {
        if (x.dim_txndate_yearmonth as number > yearMonth) {
          yearMonth = x.dim_txndate_yearmonth as number;
          yearMonthName = x.dim_txndate_yearmonthname;
        }
      });

      this.currentYearTxnCats.forEach((x) => {
        if (x.dim_txndate_yearmonth === yearMonth) {
          filteredData.push({
            data: x.fct_sum_abs_amount as number,
            label: x.dim_txncat
          });
        }
      });

      let sortedChartData = filteredData.sort((a, b) => {
        return (b.data as number) - (a.data as number);
      });

      let labels: string[] = new Array<string>();
      let data: number[] = new Array<number>();

      sortedChartData.forEach((x) => {
        labels.push(x.label as string);
        data.push(x.data as number);
      });

      this.chartData.datasets[0].data = data;
      this.chartData.labels = labels;

      this.chart?.update();
    }
  }
}
